import { GET } from 'shared/utils/ajax';

/**
 * 곡 상세
 * @param {string} upc
 */
export const getDetailSong$ = upc => GET(`/rest/media/detail/${upc}`);
